import { Route, Routes } from 'react-router-dom'
import { Shell } from './components/Shell'
import { ShareProvider } from './components/ShareModal'
import { Dashboard } from './pages/Dashboard'
import { NotFound, Placeholder } from './pages/Placeholder'
import { ACCOUNT_NAV, NAV } from './nav'

/**
 * Sidebar and account-menu destinations, deduped by path — `/settings` appears
 * in both lists, and registering a route twice would shadow the first.
 */
const DESTINATIONS = [...NAV, ...ACCOUNT_NAV]
  .filter((item) => item.path !== '/')
  .filter((item, i, all) => all.findIndex((o) => o.path === item.path) === i)

export function App() {
  return (
    <ShareProvider>
      <Shell>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          {/* every sidebar destination resolves to something honest rather
              than a dead link that silently does nothing */}
          {DESTINATIONS.map((item) => (
            <Route key={item.path} path={item.path} element={<Placeholder title={item.label} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Shell>
    </ShareProvider>
  )
}
